var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 10,
    fill: "#EBF2FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4442_10604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 26V34H26C24.5971 33.9986 23.2192 33.6282 22.0047 32.9262C20.7901 32.2241 19.7815 31.215 19.08 30C19.8339 29.9946 20.5852 29.9115 21.322 29.752C21.8832 30.4536 22.595 31.02 23.4048 31.4092C24.2146 31.7983 25.1016 32.0002 26 32H32V26C31.9998 25.1012 31.7972 24.2141 31.4074 23.4042C31.0175 22.5944 30.4504 21.8828 29.748 21.322C29.9088 20.5853 29.9933 19.834 30 19.08C31.215 19.7815 32.2241 20.7901 32.9262 22.0047C33.6282 23.2192 33.9986 24.5971 34 26ZM28 19C28 16.6131 27.0518 14.3239 25.364 12.636C23.6761 10.9482 21.3869 10 19 10C16.6131 10 14.3239 10.9482 12.636 12.636C10.9482 14.3239 10 16.6131 10 19L10 28H19C21.3861 27.9974 23.6738 27.0483 25.361 25.361C27.0483 23.6738 27.9974 21.3861 28 19ZM12 19C12 17.6155 12.4105 16.2622 13.1797 15.111C13.9489 13.9599 15.0421 13.0627 16.3212 12.5328C17.6003 12.003 19.0078 11.8644 20.3656 12.1345C21.7235 12.4046 22.9708 13.0713 23.9497 14.0503C24.9287 15.0292 25.5954 16.2765 25.8655 17.6344C26.1356 18.9922 25.997 20.3997 25.4672 21.6788C24.9373 22.9579 24.0401 24.0511 22.889 24.8203C21.7378 25.5895 20.3845 26 19 26H12V19Z",
    fill: "#314155"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4442_10604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/Comment.22eb69cd.svg";
export { ForwardRef as ReactComponent };